const ICON_STYLE = { FILLED: 'Filled', OUTLINED: 'Outlined' }

const ICON_STYLE_OPTIONS = Object.keys(ICON_STYLE).map((key) => ({
  label: ICON_STYLE[key],
  value: key
}))

export default ICON_STYLE
export { ICON_STYLE, ICON_STYLE_OPTIONS }
